const services = [
  {
    title: 'Cung ứng lao động vệ sinh hàng ngày',
    link: '/no-data',
    image: '/images/services/1.jpg',
  },
  {
    title: 'Vệ sinh sau xây dựng',
    link: '/no-data',
    image: '/images/services/2.jpg',
  },
  {
    title: 'Vệ sinh định kỳ',
    link: '/no-data',
    image: '/images/services/3.jpg',
  },
  {
    title: 'Cây xanh văn phòng',
    link: '/no-data',
    image: '/images/services/4.jpg',
  },
  {
    title: 'Quà tặng cây xanh cá nhân hóa',
    link: '/no-data',
    image: '/images/services/5.webp',
  },
  {
    title: 'Bảo trì chống thấm',
    link: '/no-data',
    image: '/images/services/6.jpg',
  },
  {
    title: 'Thi công nội, ngoại thất',
    link: '/no-data',
    image: '/images/services/7.jpg',
  },
];

export default services;
